import React from 'react'
import PropTypes from 'prop-types'
import TitleBar from '../Layout/titleBar'
import MyDialog from '../Layout/myDialog'
import { Row, Col } from 'react-flexbox-grid'
import Paper from '@material-ui/core/Paper';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import PopupState, { bindTrigger, bindMenu } from 'material-ui-popup-state/index';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import IconButton from '@material-ui/core/IconButton';
import {showError} from '../Common/notification'

const ItemRubro = (props)=>{
    /**
     * nombre : titulo del item
     * descripcion: sub titulo, una linea
     * fecha: seguna linea de sub titulo, timestamp
     * monto: cantidad a la derecha, formateada como moneda
     * opciones: lista de opciones desplegables {nombre: string, handler: func}
     * onClick: click en cualquier lugar del item
     */
        return <div onClick={props.onClick} className='containerItemRubro'>
            
            <div className='imgNombre'>
                {(props.imagen !== undefined) && 
                <img src={props.imagen}  onDragStart={(e)=>{e.preventDefault();}} alt=""/>}
                    
                <div>{props.nombre}</div>
            </div>
            {(props.opciones !== undefined) && <div onClick={(e)=>{e.stopPropagation()}}>
            <PopupState variant="popover" popupId={"nuevo-usuario-menu"}>
          {popupState => (
            <React.Fragment>
                <IconButton {...bindTrigger(popupState)}>
                    <MoreVertIcon />
                </IconButton>
              <Menu {...bindMenu(popupState)}>
                {
                    props.opciones.map((x)=>{return x!==undefined ? <MenuItem onClick={(...args)=>{x.handler(...args);popupState.close(...args)}}>{x.nombre}</MenuItem> : undefined})
                }
              </Menu>
            </React.Fragment>
          )}
        </PopupState>
            </div>}
            {(props.activo !== true) && <div style={{float:"right", fontWeight:"normal", position:"relative",fontFamily:"Roboto",color:"#FFFFFF", backgroundColor:"#E21B1B", borderRadius:"2px",padding:"1px 8px", marginRight:"5px",fontSize:"14px", top:"-10px"}}>{"Inactivo"}</div>}
        
        </div>
    }

class RubroListado extends React.Component {

    over=null;

    dragStart(e) {
        
        this.dragged = e.currentTarget;
        e.dataTransfer.effectAllowed = 'move';
        e.dataTransfer.setData('text/html', this.dragged);
      }
      dragEnd(e) {
        // update state
        var from = Number(this.dragged.dataset.id);
        var to = Number(this.over);
        if (from!==to && to!==-1){
            if(this.props.canSwap === false){ showError("No se permite ordenar los items de una busqueda. Por favor limpie la busqueda."); return; }
            this.props.handleOnSwap(from, to)
        }
      }
      dragOver(e) {
        e.preventDefault();
        if(e.target.className === 'placeholder') return;
        if(e.target.dataset.id){
            this.over = e.target.dataset.id;
            e.target.style = e.target.style + "background-color:yellow;" 
            }        
        }

    render() {
        return (
            <div data-id={-1} onDragOver={this.dragOver.bind(this)}>

                {/* menú superior */}
                <TitleBar 
                    title={'Rubros'} 
                    handleOnSearch={this.props.handleOnSearch} 
                    searchPlaceholder="Rubro"
                    showSearch = {true}
                    newButtonLink='/Rubros/Edit/0'
                />
                

                <Paper  onDragOver={this.dragOver.bind(this)} style={{backgroundColor: "transparent", boxShadow:'none'}}>
                
                    <Row style={{margin: '0px'}}>
                        {this.props.rubros.map && this.props.rubros.map((x,i)=>
                            <Col 
                                md={6} lg={4}
                                className='draggable' 
                                data-id={x.idRubro} 
                                draggable='true' 
                                onDragEnd={this.dragEnd.bind(this)} 
                                onDragStart={this.dragStart.bind(this)}
                            >
                                <ItemRubro onClick={()=>{this.props.handleOpenModal && this.props.handleOpenModal(x)}} {...this.props.mapToItem(x)}/>
                            </Col>
                        )}
                    </Row>
                
                </Paper>

                {
                this.props.openModal &&
                <MyDialog cuerpo={this.props.mensaje}  botonConfirmar={this.props.labelModalOk} handleOnConfirmar={()=>{this.props.handleModalOk(); setTimeout(this.props.handleOnSearch, 600);}} handleOnCancelar = {this.props.handleCloseModal}/>
                }

            </div>
        )
    }
}

RubroListado.propTypes = {
    rubros: PropTypes.object.isRequired,
    handleOnChange: PropTypes.func.isRequired,
    handleOnSave: PropTypes.func.isRequired,   
    handleOnSearch : PropTypes.func.isRequired,
    canSwap: PropTypes.bool,
    mensaje: PropTypes.string,
    labelModalOk: PropTypes.string,
    handleModalOk: PropTypes.func,
    handleCloseModal: PropTypes.func,
    openModal: PropTypes.bool,
}

RubroListado.defaultProps = {
    rubros: [],
    canSwap: true
}

export default RubroListado